import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http'
import { TaskList } from '../taskList/task-list.service';

export interface LessonList {
  id: number,
  name: string,
  theory?: string,
  tasks: TaskList[]
}

@Injectable({
  providedIn: 'root'
})
export class LessonListService {

  constructor(private http: HttpClient) { }
  
  GetAll(id: string) {
    return this.http.get<LessonList[]>(environment.api_url + 'api/v1.0/lessons/id/' + id + '/course');
  }
  GetTheory(id: string) {
    return this.http.get(environment.api_url + 'api/v1.0/lessons/theory/' + id);
  }
  GetTasksByLesson(id: string) {
    return this.http.get(environment.api_url + 'api/v1.0/lessons/id/' + id);
  }
  EditLesson(id: string, body) {
    return this.http.patch(environment.api_url + 'api/v1.0/lessons/id/' + id, body);
  }
  AddLesson(id: string, body) {
    return this.http.post<LessonList>(environment.api_url + 'api/v1.0/lessons/id/' + id + '/course', body);
  }
  DeleteLesson(id: string) {
    return this.http.delete(environment.api_url + 'api/v1.0/lessons/id/' + id);
  }
}
